module.exports = __webpack_public_path__ + "media/packs/images/transit/date-in-731a06beaf8d2c7ecebbfdc71eeb56e8.svg";